import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_ASSET,
  GET_ASSET_SUCCESS,
  ADD_ASSET,
  ADD_ASSET_SUCCESS,
  UPDATE_ASSET,
  UPDATE_ASSET_SUCCESS,
  DEL_ASSET,
  DEL_ASSET_SUCCESS,
  DEL_ASSET_ITEMS,
  DEL_ASSET_ITEMS_SUCCESS,
} from "../../redux/actions/actionType";
import api from "../../apis/api";

// Api functions.
function getAssetApi() {
  // api call here
  return api.asset().getAll();
}
function addAssetApi(formData) {
  return api.asset().addEdit(formData);
}
function delAssetApi(delId) {
  return api.asset().del(delId);
}
function delAssetItemApi(delId) {
  const response =  api.asset().DeleteItem(delId);
  return response;
}
// to get all asset list.
export function* handleGetAssets() {
  try {
    const response = yield call(getAssetApi);
    yield put({ type: GET_ASSET_SUCCESS, payload: response.data });
  } catch (error) {
     
  }
}
// to add asset.
export function* handleAddAsset({ payload }) {
  try {
    let formData = payload;
    const response = yield call(addAssetApi, formData);
    yield put({ type: ADD_ASSET_SUCCESS, payload: formData });
    const responseg = yield call(getAssetApi);
    yield put({ type: GET_ASSET_SUCCESS, payload: responseg.data });
  } catch (error) {
     
  }
}
// to update asset.
export function* handleUpdateAsset({ payload }) {
  try {
    let formData = payload;
    yield call(addAssetApi, formData);
    yield put({ type: UPDATE_ASSET_SUCCESS, payload: formData });
    const responseg = yield call(getAssetApi);
    yield put({ type: GET_ASSET_SUCCESS, payload: responseg.data });
  } catch (error) {
     
  }
}

// to delete asset.
export function* handleDelAsset({ payload }) {
  try {
    let delId = payload;
    yield call(delAssetApi, delId);
    yield put({ type: DEL_ASSET_SUCCESS, payload: delId });
    const responseg = yield call(getAssetApi);
    yield put({ type: GET_ASSET_SUCCESS, payload: responseg.data });
  } catch (error) {
     
  }
}
export function* handleDelAssetItem({ payload }) {
  try {
    let delId = payload;
    yield call(delAssetItemApi, delId);
    yield put({ type: DEL_ASSET_ITEMS_SUCCESS, payload: delId });
    const response = yield call(getAssetApi);
    yield put({ type: GET_ASSET_SUCCESS, payload: response.data });
  } catch (error) {
     
  }
}
// watch function.
export function* assetWatchFun() {
  yield takeLatest(GET_ASSET, handleGetAssets);
  yield takeLatest(ADD_ASSET, handleAddAsset);
  yield takeLatest(UPDATE_ASSET, handleUpdateAsset);
  yield takeLatest(DEL_ASSET, handleDelAsset);
  yield takeLatest(DEL_ASSET_ITEMS, handleDelAssetItem);
}
